export default "ef811399b967224f.png"